module.exports = __webpack_public_path__ + "static/media/icon.c6585f1e.svg";